import { render } from "./App.vue?vue&type=template&id=282fee52"
const script = {}

import "./App.vue?vue&type=style&index=0&id=282fee52&lang=css"
script.render = render

export default script